import { ToastOptions } from 'react-toastify';

export enum ToastType {
  Error = 'error',
  Success = 'success',
  Info = 'info',
}

export enum TOAST_POSITIONS {
  TOP_RIGHT = 'top-right',
}

export const TOAST_DEFAULT_POSITION = TOAST_POSITIONS.TOP_RIGHT;

export const TOAST_DEFAULT_AUTO_CLOSE_TIME = 3500;

export const TOAST_DEFAULT_OPTIONS: ToastOptions = {
  position: TOAST_DEFAULT_POSITION,
  autoClose: TOAST_DEFAULT_AUTO_CLOSE_TIME,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  draggable: true,
};
